/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
        // This line enables Change Detection profiling:
        // .then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
        // To actually run the profiler, copy the following line to the browser console:
        // ng.profiler.timeChangeDetection()
        .catch(err => console.error(err));
